<template>
    <div class="tabBox">
        <div class="line"></div>
        <div
            class="tabItem"
            :class="isActiveTab ? 'active' : ''"
            @click="tabChange('active')"
            :data-transaction-name="transactionNames.LEVEL2_TABBOX_LEFT_TAB"
        >
            {{ leftTabText }}
        </div>
        <div
            class="tabItem"
            :class="isActiveTab ? '' : 'active'"
            @click="tabChange('inactive')"
            :data-transaction-name="transactionNames.LEVEL2_TABBOX_RIGHT_TAB"
        >
            {{ rightTabText }}
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    props: {
        leftTabText: String,
        rightTabText: String,
        defaultTab: {
            type: Boolean,
            default: true
        }
    },
    data () {

        let defaultTab = this.defaultTab;
        return {
            isActiveTab: defaultTab
        };

    },
    methods: {
        tabChange ( type ) {

            if ( this.isActiveTab ) {

                if ( type === 'inactive' ) {

                    this.isActiveTab = false;

                }

            } else {

                if ( type === 'active' ) {

                    this.isActiveTab = true;

                }

            }
            this.$emit( 'tabChange', this.isActiveTab );

        }
    }
});
</script>

<style lang='less' scoped>
.tabBox {
    display: flex;
    position: relative;
    @media @mobile {
        width: 100%;
    }
    .line{
        position: absolute;
        width: 100%;
        bottom: 0;
        height: 1px;
        background-color: @line;
    }
    .tabItem {
        font-size: 18px;
        line-height: normal;
        font-weight: 500;
        font-family: @font_02;
        color: @font_secondary;
        padding: 10px 0;
        margin-right: 32px;
        opacity: 0.85;
        cursor: pointer;
        @media @mobile {
            font-size: 16px;
            font-weight: 500;
            color: @font_primary;
            margin-right: 0;
            flex: 1;
            text-align: center;
        }
        &:nth-child(1) {
            margin-right: 0.4rem;
            @media @mobile {
                margin-right: 0.56rem;
            }
        }
        &.active {
            color: @b_6;
            border-bottom: 2px solid @b_6;
        }
    }
}
</style>
